import React from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import createTheme from './theme';
import { AppStateProvider } from './states/app-state';
import Scaffold from './containers/Scaffold';
import setHotjar from './tags/hotjar'; // added by Bearer Web Developer
import metaPixelCode from './tags/metaPixelCode'; // added by Bearer Web Developer
import googleTagManager from './tags/googleTagManager'; // added by Bearer Web Developer
import ThemeModeProvider from './containers/providers/themeModeProvider'; // added by Bearer Web Developer
import { BearerApi, getRemoteConfigData } from './api/bearer-api'; // added by Bearer Web Developer
import logIndevelopment from './app/logIndevelopment'; // added by Bearer Web Developer
import MenuDrawerProvider from './containers/providers/menuDrawerContext'; // added by Bearer Web Developer
import TodayDeliveriesProvider from './containers/providers/TodayDeliveriesProvider';  // added by Bearer Web Developer

function App() {

  // added by Bearer Web Developer start
  const getinitialData = async () => {

    BearerApi.callApiWithAppCheck();
    const result = await getRemoteConfigData();
    logIndevelopment();
    if (result?.environmentCode === "PRODUCTION") {
      setHotjar();
      metaPixelCode();
      googleTagManager();
    }
  }
  React.useEffect(() => {
    getinitialData();
  }, []);
  // added by Bearer Web Developer end
  return (
    <ThemeProvider theme={createTheme}>
      <CssBaseline />
      <AppStateProvider>
        <ThemeModeProvider> {/* ThemeModeProvider wrapped by Bearer Web Developer start*/}
          <MenuDrawerProvider> {/* MenuDrawerProvider wrapped by Bearer Web Developer start*/}
            <TodayDeliveriesProvider> {/* TodayDeliveriesProvider wrapped by Bearer Web Developer start*/}
              <Scaffold />
            </TodayDeliveriesProvider> {/* TodayDeliveriesProvider wrapped by Bearer Web Developer end*/}
          </MenuDrawerProvider> {/* MenuDrawerProvider wrapped by Bearer Web Developer end*/}
        </ThemeModeProvider> {/* ThemeModeProvider wrapped by Bearer Web Developer end*/}
      </AppStateProvider>
    </ThemeProvider>
  );
}

export default App;
